import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import {
  Client,
  DisconnectControlDataIn,
  GuidDictionaryItem,
} from '../../../../api/api-reference';

@Component({
  selector: 'app-connect-disconnect-setup',
  standalone: true,
  imports: [
    RouterLink,
    FormsModule,
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
  ],
  templateUrl: './connect-disconnect-setup.component.html',
  styleUrl: './connect-disconnect-setup.component.scss',
})
export class ConnectDisconnectSetupComponent implements OnInit {
  data: DisconnectControlDataIn = new DisconnectControlDataIn();
  meterMakers: GuidDictionaryItem[] = [];

  ngOnInit(): void {
    this.getMeterMakers();
  }

  actionDictionary: Action[] = Object.keys(Action)
    .filter((key) => isNaN(Number(key)))
    .map((key) => Action[key as keyof typeof Action]);

  constructor(
    private client: Client,
    private toastr: ToastrService,
    private router: Router,
  ) {}

  getMeterMakers() {
    this.client.getAllMeterMakersForOptions().subscribe({
      next: (response) => {
        this.meterMakers = response ?? [];
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  onSubmit() {
    this.client.setConnectedState(this.data).subscribe({
      next: () => {
        this.toastr.success('Successfully saved.');
        this.router.navigate(['/remote-command/connect-disconnect']);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}

export enum Action {
  Connect = 'Connect',
  Disconnect = 'Disconnect',
}
